import React from 'react';
import './imageItem.css';
import 'react-photo-view-kcsx/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view-kcsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
//import useDeleteImage from './../../pages/cloud-invoice-ui/hooks';
import useImageData from './../../pages/cloud-invoice-ui/hooks';
const ImageItem = ({ image, onView, url }) => {
  const { deleteimg } = useImageData();

  const handleDelete = async rno => {
    await deleteimg(rno);

    // Additional logic after deletion if needed
  };
  return (
    <div className="image-item" style={{ margin: '15px' }}>
      {/* <img  
         src={url}
     //src={require("../../pages/cloud-invoice-ui/Test.jpg")}
        alt={image.info ? image.info : ''}
        height='220px'
        width='182px'
      /> */}
      <PhotoProvider>
        <PhotoView src={url}>
          <img src={url} alt="" height="220px" width="182px" />
        </PhotoView>
      </PhotoProvider>
      <div className="button-container-delete">
        <button
          className="delete-butt{ton"
          onClick={() => handleDelete(image.rno)}>
          <FontAwesomeIcon icon={faTrash} style={{ color: 'red' }} />
        </button>
      </div>
    </div>
  );
};

export default ImageItem;
